// Question text may contain the literal "[feedback receiver]" placeholder
// (used by Simple 360 Feedback). Substitute the receiver's real name at
// render time; text without the placeholder passes through unchanged.
export const RECEIVER_PLACEHOLDER = /\[feedback receiver\]/gi;

export const interpolateReceiverName = (text, fullName) =>
  !text || !fullName ? text : text.replace(RECEIVER_PLACEHOLDER, fullName);
